import type { HelpFile } from '../../types/help'
import { SapSfEcInboundConfigCardTestIds } from '../../../testids/SapSfEcInboundConfigCardTestIds'

export const sapSfEcInboundConfigCardHelp: HelpFile = {
  docPage: '/docs/connectors/sap-sf-ec-connector',
  texts: {
    [SapSfEcInboundConfigCardTestIds.sapSfEcConfigSection]:
      'OData-V2-Eingangskonnektor für SAP SuccessFactors Employee Central. Authentifizierung über OAuth2 Client Credentials oder OAuth2 SAML-2.0-Bearer-Assertion (RFC 7522) — der SAML-Pfad ist für IAS-vorgeschaltete Mandanten erforderlich.',
    [SapSfEcInboundConfigCardTestIds.cardTitleSapSfEcConfig]: null,
    [SapSfEcInboundConfigCardTestIds.btnEditSapSfEcConfig]: null,
  },
}
